import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  width: 280px;
  height: 160px;
  position: relative;
  margin: 0 auto;
`;

export const NoData = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  text-align: center;
  color: ${({ theme }) => theme.colors.gray600};
  ${getFontStyle('midium150_B3')};
`;
